import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycApprovedPage from './KycApprovedPage';

const KycApprovedRoute: FuseRouteItemType = {
  path: '',
  element: <KycApprovedPage />,
  auth: AUTH_ROLES.parent, // []
};

export default KycApprovedRoute;
